import React, { useState } from 'react';
import { Button, Upload } from '@roo/roo';
import Header from '../../components/HeaderWithoutMenu';
import './index';

const New = (props) => {
  const [isLoading, setLoading] = useState(false);
  return (
    <>
      <Header />
      <Upload
        accept="image/png, image/jpg"
        action="https://yapi.sankuai.com/mock/3284/file/upload"
        onSuccess={() => { }}
        beforeUpload={() => { }}
        onFail={() => { }}
      >
        <Button
          loading={isLoading}
        >
          上传文件
        </Button>
      </Upload>
    </>
  );
};

export default New;
